import { EActionState, IRegionGroup } from '@/models';

export interface IApplicationState {
	init: EActionState;
	drawer: IDrawerState;
	regions: IRegionGroup[];
}

export const initialState: IApplicationState = {
	init: EActionState.PENDING,
	drawer: {
		templates: {
			open: false
		},
		schedule: {
			open: false
		},
		settings: {
			open: false
		}
	},
	regions: []
};

export interface IDrawerState {
	templates: {
		open: boolean;
	};
	schedule: {
		open: boolean;
	};
	settings: {
		open: boolean;
	};
}
